// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZohoLoginButton_zohoLoginButton__plFMN {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  height: 56px;
  padding: 0 24px;
  background: #0088FF;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 136, 255, 0.25);
  letter-spacing: 0.3px;
}
.ZohoLoginButton_zohoLoginButton__plFMN:hover:not(:disabled) {
  background: #0073E6;
  box-shadow: 0 8px 20px rgba(0, 136, 255, 0.4);
  transform: translateY(-3px);
}
.ZohoLoginButton_zohoLoginButton__plFMN:active:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 136, 255, 0.3);
}
.ZohoLoginButton_zohoLoginButton__plFMN:disabled {
  background: #94c5ff;
  cursor: not-allowed;
  transform: none;
}

.ZohoLoginButton_icon__zgxZb {
  font-size: 22px;
  flex-shrink: 0;
}

.ZohoLoginButton_spinner__xstFW {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: ZohoLoginButton_spin__wTwzC 0.8s linear infinite;
}

@keyframes ZohoLoginButton_spin__wTwzC {
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/auth/ZohoLoginButton.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yKAAA;EAGA,eAAA;EACA,yBAAA;EACA,8CAAA;EACA,qBAAA;AADF;AAGE;EACE,mBAAA;EACA,6CAAA;EACA,2BAAA;AADJ;AAIE;EACE,2BAAA;EACA,6CAAA;AAFJ;AAKE;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;AAHJ;;AAOA;EACE,eAAA;EACA,cAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,yBAAA;EACA,kBAAA;EACA,2DAAA;AAJF;;AAOA;EACE;IACE,yBAAA;EAJF;AACF","sourcesContent":[".zohoLoginButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  height: 56px;\n  padding: 0 24px;\n  background: #0088FF;\n  color: #ffffff;\n  border: none;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',\n    'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(0, 136, 255, 0.25);\n  letter-spacing: 0.3px;\n\n  &:hover:not(:disabled) {\n    background: #0073E6;\n    box-shadow: 0 8px 20px rgba(0, 136, 255, 0.4);\n    transform: translateY(-3px);\n  }\n\n  &:active:not(:disabled) {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(0, 136, 255, 0.3);\n  }\n\n  &:disabled {\n    background: #94c5ff;\n    cursor: not-allowed;\n    transform: none;\n  }\n}\n\n.icon {\n  font-size: 22px;\n  flex-shrink: 0;\n}\n\n.spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"zohoLoginButton": `ZohoLoginButton_zohoLoginButton__plFMN`,
	"icon": `ZohoLoginButton_icon__zgxZb`,
	"spinner": `ZohoLoginButton_spinner__xstFW`,
	"spin": `ZohoLoginButton_spin__wTwzC`
};
export default ___CSS_LOADER_EXPORT___;
